import React from 'react'

const Manual_crear_encuestas = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Cómo crear Encuestas
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende a crear encuestas personalizadas dentro del panel de Clau.io para recopilar información valiosa de tus clientes.
        </p>
        <iframe
          src="https://scribehow.com/embed/Como_crear_Encuestas__fsYxLS5WT9qZd1eIt4MuXQ?as=scrollable"
          className="scribe-iframe-general-122"
          width="100%"
          height="9200"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_crear_encuestas
